/**
 * Module 35 (WP-35.20) — Color Delete: arm, tap a block, every block of that
 * block's colour is destroyed.
 *
 * The reference's flow is "pick a colour", but the *board* is the colour picker:
 * tapping a block is unambiguous, needs no second UI surface, and reuses the
 * WP-35.18 targeting path exactly as Hammer does. So the tapped block names the
 * colour; it is not merely one of the victims.
 *
 * Like Hammer, **no solver re-validation** (locked decision 19): removal only
 * ever adds freedom, so it cannot make a slide-out board unsolvable — or even
 * newly stuck. The caller re-checks win/stuck and nothing else.
 */
import { BlockJamAudioId } from '../../constants/audio-ids';
export const COLOR_DELETE_ID = 'colorDelete';
export const colorDeleteEffect = {
    /**
     * Any block — tapping one is how the player names a colour, so every block on
     * the board is a legal way to say it. Deliberately NOT "one block per colour":
     * making some blocks untappable would tell the player their tap was wrong when
     * the colour they meant was right.
     */
    targets(state) {
        return state.blocks.map((b) => b.id);
    },
    apply(state, targetBlockId) {
        const target = state.blocks.find((b) => b.id === targetBlockId);
        // The board can change between arming and the tap; "nothing to do" is not an
        // error, and null is how the caller spells "take no charge".
        if (!target)
            return null;
        const doomed = state.blocks.filter((b) => b.colorId === target.colorId);
        return {
            blocks: state.blocks.filter((b) => b.colorId !== target.colorId),
            removedIds: doomed.map((b) => b.id),
        };
    },
    /**
     * Module 140 (D6) — the How to Play drop: the bomb lands on the picked block
     * and every block of its colour swells and pops. Its cue rides the landing.
     */
    fx: 'bomb',
    /** Removes a whole colour at once, so it wants the broadest of the three. */
    impactAudioId: BlockJamAudioId.POWERUP_COLORDELETE,
};
